import { render, staticRenderFns } from "./p-box.vue?vue&type=template&id=ec9b81ae&scoped=true&"
import script from "./p-box.vue?vue&type=script&lang=js&"
export * from "./p-box.vue?vue&type=script&lang=js&"
import style0 from "./p-box.vue?vue&type=style&index=0&id=ec9b81ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9b81ae",
  null
  
)

export default component.exports